import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import {Icon, IconName} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {Brand} from '@vio/core/src/brand/types'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  brand: Brand
  isSingleColumn: boolean
}
export const FooterSocialSection = ({brand, isSingleColumn}: Props) => {
  return (
    <div>
      <Text variant="titleL" tag="p">
        <FormattedMessageWrapper id="social" defaultMessage="Social" />
      </Text>
      <Box paddingTop="s400">
        <Box
          display="flex"
          gap="s300"
          justifyContent={isSingleColumn ? 'center' : 'flex-start'}
        >
          <FooterSocialButton
            url={brand.socials?.instagramUrl}
            iconName="Instagram"
          />
          <FooterSocialButton
            url={brand.socials?.facebookUrl}
            iconName="Facebook"
          />
          <FooterSocialButton
            url={brand.socials?.linkedinUrl}
            iconName="Linkedin"
          />
        </Box>
      </Box>
    </div>
  )
}

interface FooterSocialButtonProps {
  url?: string
  iconName: IconName
}
const FooterSocialButton = ({url, iconName}: FooterSocialButtonProps) => {
  if (!url) {
    return null
  }
  return (
    <SocialLink href={url} target="_blank">
      <Icon name={iconName} size="lg" colorPath={'content.neutral.primary'} />
    </SocialLink>
  )
}

const SocialLink = styled(NoStyleLink)`
  height: ${cssTheme.layout.spacing.s800};
  width: ${cssTheme.layout.spacing.s800};
  border-radius: 50%;
  background-color: ${cssTheme.colors.background.neutral.primary};
  display: flex;
  justify-content: center;
  align-items: center;
`
